module.exports = __webpack_public_path__ + "d9ce610cb145c0951cc9772f343b7c8e.png";